import React from 'react'
import { classNames } from '../_utils'

const ListItem = ( { icon, label, handlePress, active } ) => {

    return (
      <button onClick={handlePress} type="button" className={`${ active ? `bg-green-700 text-white` : `bg-white` } w-full bg-white flex flex-row items-start p-2 border-b border-gray-300`}>
        <div className={`${ active ? ``: `` }rounded-full bg-blue-600 flex items-center justify-center w-6 h-6`}>
          {icon}
        </div>
        <div className="mx-3">
          <span className="text-left text-sm">{label}</span>  
        </div> 
      </button>
    )
}
export default ListItem
